import { RouteFactory } from "@app/routePaths";
import { DAILY_NEWSLETTER_SECTION_CONFIG } from "@features/newsletter/utils/constants";

/**
 * Helper function to format a text that is suited for Ads Team's requirements.
 * Examples of keyword text shown on helpers.test.tsx
 * @param {string} text The text that needs to be formatted.
 * @returns {string}
 */
export const getFormattedTextForAds = (text: string): string => {
  return text
    .replaceAll(/&amp;|&/g, "and")
    .replaceAll(/[;/\\]/g, "")
    .toLowerCase();
};

/**
 * Helper function to get the section heading class.
 * @param path The url path.
 * @returns {string}
 */
export const getSectionHeadingClass = (path: string): string => {
  if (!path) return "";

  if (path.startsWith(RouteFactory.thrive)) {
    return "pb-3 pt-6 thrive-past-event-title stroke-gray-850 stroke-1 font-interBold text-6xl font-bold leading-[2.5rem] !text-white text-shadow-thrive-2 md:text-8xl";
  }

  if (path.startsWith(RouteFactory.newsletters)) return "uppercase pb-0";

  return "uppercase";
};

/**
 * Helper function to get the section heading text.
 * @param path The url path.
 * @param text The default text.
 * @returns {string}
 */
export const getSectionHeadingText = (path: string, text: string): string => {
  if (path?.startsWith(RouteFactory.thrive)) {
    return "Let's talk Career, Money and Life.";
  }

  return text;
};

/**
 * Helper function to truncate section heading text.
 * @param isScreenXL Flag to check extra large screens.
 * @param isScreenLG Flag to check larger screens.
 * @returns {number}
 */
export const getTruncateTitleLength = (
  isScreenLG: boolean,
  isScreenXL: boolean
) => {
  if (isScreenXL) {
    return 40;
  } else if (isScreenLG) {
    return 23;
  } else {
    return 30;
  }
};

/**
 * Function to get the listing unique name for the section.
 */
export const getListingUniqueName = (uniqueName: string): string => {
  if (uniqueName === "newsletters_daily") {
    return DAILY_NEWSLETTER_SECTION_CONFIG.join(",");
  }

  return uniqueName;
};
